import React, { useEffect, useState } from "react";
import { Table, Grid, Checkbox as CheckBoxs, Button, Text, Modal, Row, Textarea, Loading } from "@nextui-org/react";
import { officials } from "../../../apis/urls";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Checkbox from './checkboxCheck'
import { Input } from "rsuite";
import { message } from "antd";
import { $ } from "react-jquery-plugin";
import moment from 'moment';


const OfficialPendingCheck =()=> {

    const {assid, assoname} = useParams();

    const [result, setResult] = useState([]);



  useEffect(()=>{
    $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
    paymentPendingStatus()
  },[])


  // TODO PAYMENT STATUS LISTING

  const paymentPendingStatus = () => {

    let token = "Bearer "+localStorage.getItem('token');

    const instance = axios.create({

        baseURL: officials+"/checkpayment/"+assid,

        timeout: 1000000,

        headers: {'authorization': token}

      });
      
      instance.get('').then((response) =>{


        console.log("daataaata", response.data.data)
        setResult(response.data.data)

        console.log("")
        
      }).catch((error) =>{
        
    });

}


const [isCheck, setIsCheck] = useState([]);
const [isCheckAll, setIsCheckAll] = useState(false);
const [payDetails, setPayDetails] = useState('')

const isSelectableCheckPayment = (official) => {
  return official.payment_mode === "CHECK";
};

const getSelectableCheckPaymentIds = (officialsList = result) => {
  return officialsList.filter(isSelectableCheckPayment).map((official) => official.id);
};

// TODO SELECT ALL

const handleSelectAll = (e) => {
  const checked = e.target.checked;
  setIsCheckAll(checked);

  if (checked) {
    setIsCheck(getSelectableCheckPaymentIds());
  } else {
    setIsCheck([]);
  }
};

// TODO INDIVIDUAL SELECT

const handleClick = (e) => {
  const { id, checked } = e.target;
  let selectId = parseInt(id)
  let updatedChecks = [...isCheck, selectId];
  if (!checked) {
    updatedChecks = isCheck.filter((item) => item !== selectId);
  }
  setIsCheck(updatedChecks);
  setIsCheckAll(updatedChecks.length === getSelectableCheckPaymentIds().length)

};

// TODO GISA ADMIN PAYMENT PENDING APPROVE

const paymentStatusChange = () => {

  let token = "Bearer "+localStorage.getItem('token');

  const data = {
    ids:isCheck,
    payment_details:payDetails
  }

  const instance = axios.create({

      baseURL: officials+"/checkpayment/approve/"+assid,

      timeout: 1000000,

      headers: {'authorization': token}

    });
    
    instance.patch('', data).then((response) =>{

      closeHandler();

      paymentPendingStatus();
      message.success('Payment successfully completed');
      
    }).catch((error) =>{
      
    });

}

// TODO MODEL 


const [visible, setVisible] = React.useState(false);
const handler = () => setVisible(true);

const closeHandler = () => {
  setVisible(false);
};



const declinedButton = (id) => {

  let token = "Bearer "+localStorage.getItem('token');

  const instance = axios.create({

      baseURL: officials+"/payment/declined/"+id,

      timeout: 1000000,

      headers: {'authorization': token}

    });
    
    instance.patch('').then((response) =>{

      paymentPendingStatus();
      message.success('Payment Declined Successfully');
      
    }).catch((error) =>{
      
    });

}



  return (
    <div className="wrapper">
      <aside class="right-side areas">
        <div class="content-area dash-contentss">


              <div class="page-title-wrpr">
                  <div class="page-title-left-column">
                      <h2 class="page-title">Payment Pending Officials List - {assoname}</h2>
                  </div>
              </div>


              <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                      <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                      <li className="breadcrumb-item active" aria-current="page"><Link to="/associations">Associations</Link></li>
                      <li className="breadcrumb-item active" aria-current="page">Officials pending</li>

                  </ol>
				      </nav>



          {result.length !== 0?
          <div> 
            <Grid.Container gap={2}>
              <Grid xs={12} >
                  <Table
                    
                    aria-label="Example dynamic collection table with color selection"
                    color="error"
                    containerCss={{
                      height: "auto",
                      minWidth: "100%",
                    }}
                  >
                    
                  <Table.Header>
                    <Table.Column>
                      <CheckBoxs onChange={handleSelectAll} isSelected={isCheckAll  } />
                    </Table.Column>
                    <Table.Column css={{color:'red'}}>NAME</Table.Column>
                    <Table.Column css={{color:'#fff'}}>EMAIL</Table.Column>
                    <Table.Column css={{color:'#fff'}}>PHONE</Table.Column>
                    <Table.Column css={{color:'#fff'}}>PAYMENT</Table.Column>
                    <Table.Column css={{color:'#fff'}}>CREATED DATE</Table.Column>
                    <Table.Column css={{color:'#fff', width:'100px'}}>&nbsp;</Table.Column>
                  </Table.Header>
                  

                  <Table.Body>
                    {result?.map((item, index, ids, name) => (
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                              classes="pending-table"
                              key={ids}
                              type="checkbox"
                              name={name}
                              id={item.id}
                              handleClicks={handleClick}
                              isChecked={isCheck.includes(item.id)}
                              disableValue={!isSelectableCheckPayment(item)}
                              className="select-individual-check"
                          />              
                        </Table.Cell>
                        <Table.Cell><span style={{fontWeight:700, textTransform:'capitalize'}}>{item.firstname + ' ' + item.lastname}</span></Table.Cell>
                        <Table.Cell><span style={{fontWeight:700}}>{item.email}</span></Table.Cell>
                        <Table.Cell><span style={{fontWeight:700}}>{item.work_phone}</span></Table.Cell>
                        <Table.Cell><span style={{fontWeight:700, color:item.payment_mode ==="CHECK"?'green':'blue'}}><i className={item.payment_mode === "ONLINE"?"icon-credit-card":"icon-banknote"}></i>&nbsp;&nbsp;{item.payment_mode}</span></Table.Cell>
                        <Table.Cell><span style={{fontWeight:700}}>{moment(item.createdAt).format('MM-DD-YYYY')}</span></Table.Cell>
                        <Table.Cell>
                          {
                            item.payment_mode === "CHECK" &&
                              <Button onPress={()=> {declinedButton(item.id)}} style={{width:'60%', borderRadius:'5px', padding:'20px'}} shadow color="error" auto>
                                <Text style={{fontSize:'15px', color:'#fff', fontWeight:'900'}}>Decline</Text>
                              </Button>
                          }
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>

                </Table>
              </Grid>
            </Grid.Container>

            <Grid.Container gap={2}>
              <Grid xs={12} style={{justifyContent:'flex-end'}}>
                <Button style={{width:'15%', borderRadius:'5px', padding:'20px'}} onClick={handler} shadow color="primary" auto>
                  <Text style={{fontSize:'15px', color:'#fff', fontWeight:'900'}}>Approve Payment</Text>
                </Button>
              </Grid>
            </Grid.Container>



            <Modal
              closeButton
              aria-labelledby="modal-title"
              open={visible}
              onClose={closeHandler}
            >
              <Modal.Header>
                  <Text h1 size={30} 
                  css={{textGradient: "45deg, $yellow600 -20%, $red600 100%"}} weight="bold">
                      Confirmation
                  </Text>
              </Modal.Header>
              <Modal.Body>
                <Row justify="space-between">
                  <Input onChange={(value)=>setPayDetails(value)} className="text-area-pending" as="textarea" rows={3} placeholder="Enter Something" />
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Grid.Container>
                  <Grid xs={6} style={{justifyContent:'flex-start'}}>
                    <Button auto flat color="error" onClick={closeHandler} style={{width:'60%', borderRadius:'5px', padding:'18px'}}>
                      <Text style={{fontSize:'12px',color:'crimson', fontWeight:'900'}}>Close</Text>
                    </Button>
                  </Grid>
                  <Grid xs={6} style={{justifyContent:'flex-end'}}>
                    <Button auto onClick={paymentStatusChange} style={{width:'60%', borderRadius:'5px', padding:'18px'}}>
                      <Text style={{fontSize:'12px',color:'#fff', fontWeight:'900'}}>Confirm</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Modal.Footer>
            </Modal>
            </div>:
            
            <Grid.Container style={{marginTop:'10%'}}>
              <Grid xs={12} style={{justifyContent:'center'}}>
                <Text h1>Sorry! No Result Found</Text>
              </Grid>
            </Grid.Container>

            }
          </div>
        </aside>
    </div>
  );
}

export default OfficialPendingCheck
